import i18next from 'i18next';

import {
  PayinNotAssignedReason,
  PayinProviderErrorGroup,
  PayinProviderScope,
  PayinRequisitesKind,
  PayinStatisticsGroupBy,
} from 'enums';

const KEY_PREFIX = 'features.statistics.provider_conversion';

const getErrorGroupLabel = (group: PayinProviderErrorGroup) =>
  i18next.t(`${KEY_PREFIX}.errors.group_name.${group}`, {
    defaultValue: group,
  });

const getNotAssignedReasonLabel = (code: PayinNotAssignedReason) =>
  i18next.t(`${KEY_PREFIX}.not_assigned.reason.${code}`, {
    defaultValue: code,
  });

const getRequisitesKindLabel = (kind: PayinRequisitesKind) =>
  i18next.t(`${KEY_PREFIX}.requisites_kind.${kind}`, { defaultValue: kind });

const getScopeHint = (scope: PayinProviderScope) =>
  i18next.t(`${KEY_PREFIX}.cancel_reasons.scope_${scope}`, {
    defaultValue: '',
  });

const getGroupByLabel = (groupBy: PayinStatisticsGroupBy) =>
  i18next.t(`${KEY_PREFIX}.group_by.${groupBy}`, { defaultValue: groupBy });

const getOperationLabel = (operation: string) =>
  i18next.t(`features.orders.p2p_providers_requests.operation.${operation}`, {
    defaultValue: operation,
  });

export const payinProviderStatisticsUtils = {
  getErrorGroupLabel,
  getGroupByLabel,
  getNotAssignedReasonLabel,
  getOperationLabel,
  getRequisitesKindLabel,
  getScopeHint,
};
